<template>
  <!-- <el-date-picker
    v-model="value"
    type="date"
    :placeholder="placeholder"
    :picker-options="pickerOptions"
    @change="changeValue">
  </el-date-picker> -->
  <!-- :align="getAlign"
    @change="changeValue"
    :disabled="disabled" -->
  <el-date-picker
    class="pickerWidth"
    v-if="options[0]"
    v-model="currentValue"
    :type="dateType"
    :align="getAlign"
    :disabled="disabled"
    :placeholder="placeholder"
    :picker-options="expireTimeOption"
    @change="changeValue">
  </el-date-picker>
  <el-date-picker
    class="pickerWidth"
    v-else
    v-model="currentValue"
    :type="dateType"
    :align="getAlign"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="changeValue">
  </el-date-picker>
</template>

<script>
import moment from 'moment'

export default {
  props: {
    dateType: {
      type: String,
      default: 'date'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择日期'
    },
    dataType: {
      type: String,
      default: 'number'
    },
    value: {
      type: String | Number
    },
    shortcuts: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => [false]
    }
  },
  data () {
    return {
      val: '',
      pickerOptions: {
        disabledDate (time) {
          return time
        }
      },
      expireTimeOption: {
        disabledDate (date) {
          // return date.getTime() > Date.now() - 1
          let nowData = new Date()
          nowData = new Date(nowData.setDate(nowData.getDate() - 1))
          return date > nowData
        }
      }
    }
  },
  computed: {
    getAlign () {
      return this.shortcuts.length ? 'align' : ''
    },
    currentValue: {
      get () {
        return moment(this.value, 'x').toISOString()
      },
      set (value) {
        const dateValue = value ? moment(value).format('x') : ''
        this.$emit('input', dateValue) // 时间戳
      }
    }
  },
  methods: {
    changeValue (value) {
      // const dateValue = value ? Number(moment(value).format('x')) : ''
      const dateValue = value ? this.formatValue(value, this.dataType) : ''
      this.$emit('changeValue', dateValue)
    },
    formatValue (value, dataType) {
      if (dataType === 'string') {
        return moment(value).format('YYYY-MM-DD')
      }
      if (dataType === 'number') {
        return Number(moment(value).format('x'))
      }
    }
  }
}
</script>
<style scoped lang="sass">
  .pickerWidth
    width: 100%
    border-color: #e8e8e8
</style>



// WEBPACK FOOTER //
// SmartDate.vue?52f116fe